



import Vue from 'vue';
import {Component, Prop } from 'vue-property-decorator';

/**
 * Echoes are used to assert to the user that an action is being done on their behalf, such as when a default is applied
 * from somewhere else, or a decision they made elsewhere is affecting the current interface. Rather similar to a ※.
 *
 * @status stable
 * @published 5.0.0
 * @changelog 5.0.0 Published with form revamp.
 */
@Component({
})
export default class JdsEcho extends Vue {
}
